<div class="container">
    <div class="row">
        <div class="col-12">
            <h2>
                Consulta ahora si tienes cupo:
            </h2>
        </div>

        <div class="col-12">
            <div class="step-item"><span class="step-number">1.</span><span class="step-text"> Inicia sesión con tu usuario y clave Bancolombia; tienes 1 hora para completar el proceso de crédito.</span></div>
            <div class="step-item"><span class="step-number">2.</span><span class="step-text"> Conoce y acepta los Términos y Condiciones de Crédito Bancolombia y la Autorización para el tratamiento de datos personales.</span></div>
            <div class="step-item"><span class="step-number">3.</span><span class="step-text"> Consulta si tienes un cupo preaprobado para el préstamo.</span></div>
            <div class="step-item"><span class="step-number">4.</span><span class="step-text"> Decide cómo te gustaría usar tu cupo preaprobado.</span></div>
        </div>

        <div class="col-12">
            <div class="info-box">
                <img src="assets/icons/Ico-Info.svg" class="info-icon" alt="info" />
                <span>Para evitar interrupciones, <strong>no inicies sesión desde otro dispositivo</strong> durante el proceso de generación del crédito.</span>
            </div>
        </div>

        <div class="col-12 text-center btn-group-modal">
            <button class="btn-primary-modal" [class.btn-loading]="isLoading" (click)="confirm()" [disabled]="isLoading">
              @if (isLoading) {
                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              } @else {
                <span>Continuar</span> <i class="fa fa-chevron-right" aria-hidden="true"></i>
              }
            </button>
            <button class="btn-secondary-modal" (click)="cancel()"><span>Cancelar</span> <i class="fa fa-chevron-right" aria-hidden="true"></i></button>
        </div>

        <div class="col-12 modal-footer-legal">
            <div class="footer-inner">
                <img src="assets/images/bancolombia/vigilado_logo.svg" alt="Vigilado" class="vigilado-logo" />
                <div class="footer-content">
                    <p class="legal-text">El producto financiero de crédito es prestado por Bancolombia S.A. y DataCrédito Experian, corresponsal digital de Bancolombia S.A.</p>
                    <div class="logos-row">
                        <img src="assets/images/bancolombia/bancolombia_logo.svg" alt="Bancolombia" class="logo-bancolombia" />
                        <div class="logo-divider"></div>
                        <img  src="assets/images/bancolombia/datacredito_logo.svg" alt="DataCrédito Experian" class="logo-datacredito" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
